export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET';

// CUSTOMER CONSTANTS
export const CUSTOMER_LIST_REQUEST = "CUSTOMER_LIST_REQUEST";
export const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
export const CUSTOMER_LIST_FAIL = "CUSTOMER_LIST_FAIL";
export const CUSTOMER_LIST_RESET = "CUSTOMER_LIST_RESET";

export const CUSTOMER_GET_ALL_REQUEST = "CUSTOMER_GET_ALL_REQUEST";
export const CUSTOMER_GET_ALL_SUCCESS = "CUSTOMER_GET_ALL_SUCCESS";
export const CUSTOMER_GET_ALL_FAIL = "CUSTOMER_GET_ALL_FAIL";

export const CUSTOMER_DETAILS_REQUEST = "CUSTOMER_DETAILS_REQUEST";
export const CUSTOMER_DETAILS_SUCCESS = "CUSTOMER_DETAILS_SUCCESS";
export const CUSTOMER_DETAILS_FAIL = "CUSTOMER_DETAILS_FAIL";
export const CUSTOMER_DETAILS_RESET = "CUSTOMER_DETAILS_RESET";

export const CUSTOMER_CREATE_REQUEST = "CUSTOMER_CREATE_REQUEST";
export const CUSTOMER_CREATE_SUCCESS = "CUSTOMER_CREATE_SUCCESS";
export const CUSTOMER_CREATE_FAIL = "CUSTOMER_CREATE_FAIL";
export const CUSTOMER_CREATE_RESET = "CUSTOMER_CREATE_RESET";

export const CUSTOMER_UPDATE_REQUEST = "CUSTOMER_UPDATE_REQUEST";
export const CUSTOMER_UPDATE_SUCCESS = "CUSTOMER_UPDATE_SUCCESS";
export const CUSTOMER_UPDATE_FAIL = "CUSTOMER_UPDATE_FAIL";
export const CUSTOMER_UPDATE_RESET = "CUSTOMER_UPDATE_RESET";

// Dashboard Metrics
export const DASHBOARD_METRICS_REQUEST = "DASHBOARD_METRICS_REQUEST";
export const DASHBOARD_METRICS_SUCCESS = "DASHBOARD_METRICS_SUCCESS";
export const DASHBOARD_METRICS_FAIL = "DASHBOARD_METRICS_FAIL";
export const DASHBOARD_METRICS_RESET = "DASHBOARD_METRICS_RESET";

export const DASHBOARD_USER_METRICS_REQUEST = "DASHBOARD_USER_METRICS_REQUEST";
export const DASHBOARD_USER_METRICS_SUCCESS = "DASHBOARD_USER_METRICS_SUCCESS";
export const DASHBOARD_USER_METRICS_FAIL = "DASHBOARD_USER_METRICS_FAIL";

export const DASHBOARD_EMAIL_METRICS_REQUEST = "DASHBOARD_EMAIL_METRICS_REQUEST";
export const DASHBOARD_EMAIL_METRICS_SUCCESS = "DASHBOARD_EMAIL_METRICS_SUCCESS";
export const DASHBOARD_EMAIL_METRICS_FAIL = "DASHBOARD_EMAIL_METRICS_FAIL";

export const DASHBOARD_SMS_METRICS_REQUEST = "DASHBOARD_SMS_METRICS_REQUEST";
export const DASHBOARD_SMS_METRICS_SUCCESS = "DASHBOARD_SMS_METRICS_SUCCESS";
export const DASHBOARD_SMS_METRICS_FAIL = "DASHBOARD_SMS_METRICS_FAIL";

export const DASHBOARD_REVENUE_METRICS_REQUEST = "DASHBOARD_REVENUE_METRICS_REQUEST";
export const DASHBOARD_REVENUE_METRICS_SUCCESS = "DASHBOARD_REVENUE_METRICS_SUCCESS";
export const DASHBOARD_REVENUE_METRICS_FAIL = "DASHBOARD_REVENUE_METRICS_FAIL";

export const DASHBOARD_PERFORMANCE_METRICS_REQUEST = "DASHBOARD_PERFORMANCE_METRICS_REQUEST";
export const DASHBOARD_PERFORMANCE_METRICS_SUCCESS = "DASHBOARD_PERFORMANCE_METRICS_SUCCESS";
export const DASHBOARD_PERFORMANCE_METRICS_FAIL = "DASHBOARD_PERFORMANCE_METRICS_FAIL";


export const PRODUCTS_PAGED_REQUEST = 'PRODUCTS_PAGED_REQUEST';
export const PRODUCTS_PAGED_SUCCESS = 'PRODUCTS_PAGED_SUCCESS';
export const PRODUCTS_PAGED_FAIL = 'PRODUCTS_PAGED_FAIL';

export const PRODUCTS_ALL_REQUEST = 'PRODUCTS_ALL_REQUEST';
export const PRODUCTS_ALL_SUCCESS = 'PRODUCTS_ALL_SUCCESS';
export const PRODUCTS_ALL_FAIL = 'PRODUCTS_ALL_FAIL';

export const PRODUCT_DETAILS_REQUEST = 'PRODUCT_DETAILS_REQUEST';
export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS_SUCCESS';
export const PRODUCT_DETAILS_FAIL = 'PRODUCT_DETAILS_FAIL';

export const PRODUCT_CREATE_REQUEST = 'PRODUCT_CREATE_REQUEST';
export const PRODUCT_CREATE_SUCCESS = 'PRODUCT_CREATE_SUCCESS';
export const PRODUCT_CREATE_FAIL = 'PRODUCT_CREATE_FAIL';
export const PRODUCT_CREATE_RESET = 'PRODUCT_CREATE_RESET';

export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PRODUCT_UPDATE_SUCCESS = 'PRODUCT_UPDATE_SUCCESS';
export const PRODUCT_UPDATE_FAIL = 'PRODUCT_UPDATE_FAIL';
export const PRODUCT_UPDATE_RESET = 'PRODUCT_UPDATE_RESET';

export const PRODUCT_DELETE_REQUEST = 'PRODUCT_DELETE_REQUEST';
export const PRODUCT_DELETE_SUCCESS = 'PRODUCT_DELETE_SUCCESS';
export const PRODUCT_DELETE_FAIL = 'PRODUCT_DELETE_FAIL';

export const PRODUCT_UPDATE_PRICING_REQUEST = 'PRODUCT_UPDATE_PRICING_REQUEST';
export const PRODUCT_UPDATE_PRICING_SUCCESS = 'PRODUCT_UPDATE_PRICING_SUCCESS';
export const PRODUCT_UPDATE_PRICING_FAIL = 'PRODUCT_UPDATE_PRICING_FAIL';

//
// Images
export const PRODUCT_IMAGES_REQUEST = 'PRODUCT_IMAGES_REQUEST';
export const PRODUCT_IMAGES_SUCCESS = 'PRODUCT_IMAGES_SUCCESS';
export const PRODUCT_IMAGES_FAIL = 'PRODUCT_IMAGES_FAIL';

export const PRODUCT_IMAGE_CREATE_REQUEST = 'PRODUCT_IMAGE_CREATE_REQUEST';
export const PRODUCT_IMAGE_CREATE_SUCCESS = 'PRODUCT_IMAGE_CREATE_SUCCESS';
export const PRODUCT_IMAGE_CREATE_FAIL = 'PRODUCT_IMAGE_CREATE_FAIL';

export const PRODUCT_IMAGE_UPDATE_REQUEST = 'PRODUCT_IMAGE_UPDATE_REQUEST';
export const PRODUCT_IMAGE_UPDATE_SUCCESS = 'PRODUCT_IMAGE_UPDATE_SUCCESS';
export const PRODUCT_IMAGE_UPDATE_FAIL = 'PRODUCT_IMAGE_UPDATE_FAIL';

export const PRODUCT_IMAGE_DELETE_REQUEST = 'PRODUCT_IMAGE_DELETE_REQUEST';
export const PRODUCT_IMAGE_DELETE_SUCCESS = 'PRODUCT_IMAGE_DELETE_SUCCESS';
export const PRODUCT_IMAGE_DELETE_FAIL = 'PRODUCT_IMAGE_DELETE_FAIL';

//
// Variants
export const PRODUCT_VARIANTS_REQUEST = 'PRODUCT_VARIANTS_REQUEST';
export const PRODUCT_VARIANTS_SUCCESS = 'PRODUCT_VARIANTS_SUCCESS';
export const PRODUCT_VARIANTS_FAIL = 'PRODUCT_VARIANTS_FAIL';

export const PRODUCT_VARIANT_CREATE_REQUEST = 'PRODUCT_VARIANT_CREATE_REQUEST';
export const PRODUCT_VARIANT_CREATE_SUCCESS = 'PRODUCT_VARIANT_CREATE_SUCCESS';
export const PRODUCT_VARIANT_CREATE_FAIL = 'PRODUCT_VARIANT_CREATE_FAIL';

export const PRODUCT_VARIANT_UPDATE_REQUEST = 'PRODUCT_VARIANT_UPDATE_REQUEST';
export const PRODUCT_VARIANT_UPDATE_SUCCESS = 'PRODUCT_VARIANT_UPDATE_SUCCESS';
export const PRODUCT_VARIANT_UPDATE_FAIL = 'PRODUCT_VARIANT_UPDATE_FAIL';

export const PRODUCT_VARIANT_DELETE_REQUEST = 'PRODUCT_VARIANT_DELETE_REQUEST';
export const PRODUCT_VARIANT_DELETE_SUCCESS = 'PRODUCT_VARIANT_DELETE_SUCCESS';
export const PRODUCT_VARIANT_DELETE_FAIL = 'PRODUCT_VARIANT_DELETE_FAIL';

//
// Pricing rules
export const PRODUCT_PRICING_RULES_REQUEST = 'PRODUCT_PRICING_RULES_REQUEST';
export const PRODUCT_PRICING_RULES_SUCCESS = 'PRODUCT_PRICING_RULES_SUCCESS';
export const PRODUCT_PRICING_RULES_FAIL = 'PRODUCT_PRICING_RULES_FAIL';

export const PRODUCT_PRICING_RULE_CREATE_REQUEST = 'PRODUCT_PRICING_RULE_CREATE_REQUEST';
export const PRODUCT_PRICING_RULE_CREATE_SUCCESS = 'PRODUCT_PRICING_RULE_CREATE_SUCCESS';
export const PRODUCT_PRICING_RULE_CREATE_FAIL = 'PRODUCT_PRICING_RULE_CREATE_FAIL';

export const PRODUCT_PRICING_RULE_UPDATE_REQUEST = 'PRODUCT_PRICING_RULE_UPDATE_REQUEST';
export const PRODUCT_PRICING_RULE_UPDATE_SUCCESS = 'PRODUCT_PRICING_RULE_UPDATE_SUCCESS';
export const PRODUCT_PRICING_RULE_UPDATE_FAIL = 'PRODUCT_PRICING_RULE_UPDATE_FAIL';

export const PRODUCT_PRICING_RULE_DELETE_REQUEST = 'PRODUCT_PRICING_RULE_DELETE_REQUEST';
export const PRODUCT_PRICING_RULE_DELETE_SUCCESS = 'PRODUCT_PRICING_RULE_DELETE_SUCCESS';
export const PRODUCT_PRICING_RULE_DELETE_FAIL = 'PRODUCT_PRICING_RULE_DELETE_FAIL';

// PODCASTS
export const PODCAST_LIST_REQUEST = "PODCAST_LIST_REQUEST";
export const PODCAST_LIST_SUCCESS = "PODCAST_LIST_SUCCESS";
export const PODCAST_LIST_FAIL = "PODCAST_LIST_FAIL";
export const PODCAST_LIST_RESET = "PODCAST_LIST_RESET";

export const PODCAST_DETAILS_REQUEST = "PODCAST_DETAILS_REQUEST";
export const PODCAST_DETAILS_SUCCESS = "PODCAST_DETAILS_SUCCESS";
export const PODCAST_DETAILS_FAIL = "PODCAST_DETAILS_FAIL";

export const PODCAST_CREATE_REQUEST = "PODCAST_CREATE_REQUEST";
export const PODCAST_CREATE_SUCCESS = "PODCAST_CREATE_SUCCESS";
export const PODCAST_CREATE_FAIL = "PODCAST_CREATE_FAIL";
export const PODCAST_CREATE_RESET = "PODCAST_CREATE_RESET";

export const PODCAST_UPDATE_REQUEST = "PODCAST_UPDATE_REQUEST";
export const PODCAST_UPDATE_SUCCESS = "PODCAST_UPDATE_SUCCESS";
export const PODCAST_UPDATE_FAIL = "PODCAST_UPDATE_FAIL";
export const PODCAST_UPDATE_RESET = "PODCAST_UPDATE_RESET";

export const PODCAST_DELETE_REQUEST = "PODCAST_DELETE_REQUEST";
export const PODCAST_DELETE_SUCCESS = "PODCAST_DELETE_SUCCESS";
export const PODCAST_DELETE_FAIL = "PODCAST_DELETE_FAIL";
export const PODCAST_DELETE_RESET = "PODCAST_DELETE_RESET";

export const PODCAST_STATS_REQUEST = 'PODCAST_STATS_REQUEST';
export const PODCAST_STATS_SUCCESS = 'PODCAST_STATS_SUCCESS';
export const PODCAST_STATS_FAIL = 'PODCAST_STATS_FAIL';
export const PODCAST_STATS_RESET = 'PODCAST_STATS_RESET';

// PAYMENT METHOD CONSTANTS
export const PAYMENT_METHOD_LIST_REQUEST = "PAYMENT_METHOD_LIST_REQUEST";
export const PAYMENT_METHOD_LIST_SUCCESS = "PAYMENT_METHOD_LIST_SUCCESS";
export const PAYMENT_METHOD_LIST_FAIL = "PAYMENT_METHOD_LIST_FAIL";

export const PAYMENT_METHOD_CODES_REQUEST = "PAYMENT_METHOD_CODES_REQUEST";
export const PAYMENT_METHOD_CODES_SUCCESS = "PAYMENT_METHOD_CODES_SUCCESS";
export const PAYMENT_METHOD_CODES_FAIL = "PAYMENT_METHOD_CODES_FAIL";

export const PAYMENT_METHOD_PAGED_REQUEST = "PAYMENT_METHOD_PAGED_REQUEST";
export const PAYMENT_METHOD_PAGED_SUCCESS = "PAYMENT_METHOD_PAGED_SUCCESS";
export const PAYMENT_METHOD_PAGED_FAIL = "PAYMENT_METHOD_PAGED_FAIL";

export const PAYMENT_METHOD_DETAILS_REQUEST = "PAYMENT_METHOD_DETAILS_REQUEST";
export const PAYMENT_METHOD_DETAILS_SUCCESS = "PAYMENT_METHOD_DETAILS_SUCCESS";
export const PAYMENT_METHOD_DETAILS_FAIL = "PAYMENT_METHOD_DETAILS_FAIL";

export const PAYMENT_METHOD_CREATE_REQUEST = "PAYMENT_METHOD_CREATE_REQUEST";
export const PAYMENT_METHOD_CREATE_SUCCESS = "PAYMENT_METHOD_CREATE_SUCCESS";
export const PAYMENT_METHOD_CREATE_FAIL = "PAYMENT_METHOD_CREATE_FAIL";
export const PAYMENT_METHOD_CREATE_RESET = "PAYMENT_METHOD_CREATE_RESET";

export const PAYMENT_METHOD_UPDATE_REQUEST = "PAYMENT_METHOD_UPDATE_REQUEST";
export const PAYMENT_METHOD_UPDATE_SUCCESS = "PAYMENT_METHOD_UPDATE_SUCCESS";
export const PAYMENT_METHOD_UPDATE_FAIL = "PAYMENT_METHOD_UPDATE_FAIL";
export const PAYMENT_METHOD_UPDATE_RESET = "PAYMENT_METHOD_UPDATE_RESET";

export const PAYMENT_METHOD_DELETE_REQUEST = "PAYMENT_METHOD_DELETE_REQUEST";
export const PAYMENT_METHOD_DELETE_SUCCESS = "PAYMENT_METHOD_DELETE_SUCCESS";
export const PAYMENT_METHOD_DELETE_FAIL = "PAYMENT_METHOD_DELETE_FAIL";

// FEES CONSTANTS
export const FEE_LIST_REQUEST = "FEE_LIST_REQUEST";
export const FEE_LIST_SUCCESS = "FEE_LIST_SUCCESS";
export const FEE_LIST_FAIL = "FEE_LIST_FAIL";

export const FEE_PAGED_REQUEST = "FEE_PAGED_REQUEST";
export const FEE_PAGED_SUCCESS = "FEE_PAGED_SUCCESS";
export const FEE_PAGED_FAIL = "FEE_PAGED_FAIL";

export const FEE_DETAILS_REQUEST = "FEE_DETAILS_REQUEST";
export const FEE_DETAILS_SUCCESS = "FEE_DETAILS_SUCCESS";
export const FEE_DETAILS_FAIL = "FEE_DETAILS_FAIL";

export const FEE_CREATE_REQUEST = "FEE_CREATE_REQUEST";
export const FEE_CREATE_SUCCESS = "FEE_CREATE_SUCCESS";
export const FEE_CREATE_FAIL = "FEE_CREATE_FAIL";
export const FEE_CREATE_RESET = "FEE_CREATE_RESET";

export const FEE_UPDATE_REQUEST = "FEE_UPDATE_REQUEST";
export const FEE_UPDATE_SUCCESS = "FEE_UPDATE_SUCCESS";
export const FEE_UPDATE_FAIL = "FEE_UPDATE_FAIL";
export const FEE_UPDATE_RESET = "FEE_UPDATE_RESET";

export const FEE_DELETE_REQUEST = "FEE_DELETE_REQUEST";
export const FEE_DELETE_SUCCESS = "FEE_DELETE_SUCCESS";
export const FEE_DELETE_FAIL = "FEE_DELETE_FAIL";

export const ACCOUNT_PAGED_REQUEST = "ACCOUNT_PAGED_REQUEST";
export const ACCOUNT_PAGED_SUCCESS = "ACCOUNT_PAGED_SUCCESS";
export const ACCOUNT_PAGED_FAIL = "ACCOUNT_PAGED_FAIL";

export const ACCOUNT_SUBSCRIBE_EMAIL_REQUEST = "ACCOUNT_SUBSCRIBE_EMAIL_REQUEST";
export const ACCOUNT_SUBSCRIBE_EMAIL_SUCCESS = "ACCOUNT_SUBSCRIBE_EMAIL_SUCCESS";
export const ACCOUNT_SUBSCRIBE_EMAIL_FAIL = "ACCOUNT_SUBSCRIBE_EMAIL_FAIL";

export const ACCOUNT_SUBSCRIBE_SMS_REQUEST = "ACCOUNT_SUBSCRIBE_SMS_REQUEST";
export const ACCOUNT_SUBSCRIBE_SMS_SUCCESS = "ACCOUNT_SUBSCRIBE_SMS_SUCCESS";
export const ACCOUNT_SUBSCRIBE_SMS_FAIL = "ACCOUNT_SUBSCRIBE_SMS_FAIL";

export const ACCOUNT_CHANGE_SMS_OVERDRAFT_REQUEST = "ACCOUNT_CHANGE_SMS_OVERDRAFT_REQUEST";
export const ACCOUNT_CHANGE_SMS_OVERDRAFT_SUCCESS = "ACCOUNT_CHANGE_SMS_OVERDRAFT_SUCCESS";
export const ACCOUNT_CHANGE_SMS_OVERDRAFT_FAIL = "ACCOUNT_CHANGE_SMS_OVERDRAFT_FAIL";

export const ACCOUNT_CHANGE_EMAIL_OVERDRAFT_REQUEST = "ACCOUNT_CHANGE_EMAIL_OVERDRAFT_REQUEST";
export const ACCOUNT_CHANGE_EMAIL_OVERDRAFT_SUCCESS = "ACCOUNT_CHANGE_EMAIL_OVERDRAFT_SUCCESS";
export const ACCOUNT_CHANGE_EMAIL_OVERDRAFT_FAIL = "ACCOUNT_CHANGE_EMAIL_OVERDRAFT_FAIL";

// === AUDIT TRAIL CONSTANTS ===

// List all audits (paged)
export const AUDIT_LIST_REQUEST = "AUDIT_LIST_REQUEST";
export const AUDIT_LIST_SUCCESS = "AUDIT_LIST_SUCCESS";
export const AUDIT_LIST_FAIL = "AUDIT_LIST_FAIL";

// User audits by period
export const USER_AUDIT_PERIOD_REQUEST = "USER_AUDIT_PERIOD_REQUEST";
export const USER_AUDIT_PERIOD_SUCCESS = "USER_AUDIT_PERIOD_SUCCESS";
export const USER_AUDIT_PERIOD_FAIL = "USER_AUDIT_PERIOD_FAIL";

// My audits by period
export const MY_AUDIT_PERIOD_REQUEST = "MY_AUDIT_PERIOD_REQUEST";
export const MY_AUDIT_PERIOD_SUCCESS = "MY_AUDIT_PERIOD_SUCCESS";
export const MY_AUDIT_PERIOD_FAIL = "MY_AUDIT_PERIOD_FAIL";

// Single audit details
export const AUDIT_DETAILS_REQUEST = "AUDIT_DETAILS_REQUEST";
export const AUDIT_DETAILS_SUCCESS = "AUDIT_DETAILS_SUCCESS";
export const AUDIT_DETAILS_FAIL = "AUDIT_DETAILS_FAIL";

// === E-SOLUTIONS SMS ACCOUNT ===

// Fetch account
export const ESOLUTIONS_SMS_ACCOUNT_REQUEST = "ESOLUTIONS_SMS_ACCOUNT_REQUEST";
export const ESOLUTIONS_SMS_ACCOUNT_SUCCESS = "ESOLUTIONS_SMS_ACCOUNT_SUCCESS";
export const ESOLUTIONS_SMS_ACCOUNT_FAIL = "ESOLUTIONS_SMS_ACCOUNT_FAIL";

// Update account
export const ESOLUTIONS_SMS_ACCOUNT_UPDATE_REQUEST = "ESOLUTIONS_SMS_ACCOUNT_UPDATE_REQUEST";
export const ESOLUTIONS_SMS_ACCOUNT_UPDATE_SUCCESS = "ESOLUTIONS_SMS_ACCOUNT_UPDATE_SUCCESS";
export const ESOLUTIONS_SMS_ACCOUNT_UPDATE_FAIL = "ESOLUTIONS_SMS_ACCOUNT_UPDATE_FAIL";


// === EMAIL PACKAGE CONSTANTS ===

// Create
export const EMAIL_PACKAGE_CREATE_REQUEST = "EMAIL_PACKAGE_CREATE_REQUEST";
export const EMAIL_PACKAGE_CREATE_SUCCESS = "EMAIL_PACKAGE_CREATE_SUCCESS";
export const EMAIL_PACKAGE_CREATE_FAIL = "EMAIL_PACKAGE_CREATE_FAIL";
export const EMAIL_PACKAGE_CREATE_RESET = "EMAIL_PACKAGE_CREATE_RESET";

// Update
export const EMAIL_PACKAGE_UPDATE_REQUEST = "EMAIL_PACKAGE_UPDATE_REQUEST";
export const EMAIL_PACKAGE_UPDATE_SUCCESS = "EMAIL_PACKAGE_UPDATE_SUCCESS";
export const EMAIL_PACKAGE_UPDATE_FAIL = "EMAIL_PACKAGE_UPDATE_FAIL";
export const EMAIL_PACKAGE_UPDATE_RESET = "EMAIL_PACKAGE_UPDATE_RESET";

// Delete
export const EMAIL_PACKAGE_DELETE_REQUEST = "EMAIL_PACKAGE_DELETE_REQUEST";
export const EMAIL_PACKAGE_DELETE_SUCCESS = "EMAIL_PACKAGE_DELETE_SUCCESS";
export const EMAIL_PACKAGE_DELETE_FAIL = "EMAIL_PACKAGE_DELETE_FAIL";

// Get paginated
export const EMAIL_PACKAGE_PAGED_REQUEST = "EMAIL_PACKAGE_PAGED_REQUEST";
export const EMAIL_PACKAGE_PAGED_SUCCESS = "EMAIL_PACKAGE_PAGED_SUCCESS";
export const EMAIL_PACKAGE_PAGED_FAIL = "EMAIL_PACKAGE_PAGED_FAIL";

// Get all (unpaged)
export const EMAIL_PACKAGE_LIST_REQUEST = "EMAIL_PACKAGE_LIST_REQUEST";
export const EMAIL_PACKAGE_LIST_SUCCESS = "EMAIL_PACKAGE_LIST_SUCCESS";
export const EMAIL_PACKAGE_LIST_FAIL = "EMAIL_PACKAGE_LIST_FAIL";

// === SMS PACKAGE CONSTANTS ===

// Create
export const SMS_PACKAGE_CREATE_REQUEST = "SMS_PACKAGE_CREATE_REQUEST";
export const SMS_PACKAGE_CREATE_SUCCESS = "SMS_PACKAGE_CREATE_SUCCESS";
export const SMS_PACKAGE_CREATE_FAIL = "SMS_PACKAGE_CREATE_FAIL";
export const SMS_PACKAGE_CREATE_RESET = "SMS_PACKAGE_CREATE_RESET";

// Update
export const SMS_PACKAGE_UPDATE_REQUEST = "SMS_PACKAGE_UPDATE_REQUEST";
export const SMS_PACKAGE_UPDATE_SUCCESS = "SMS_PACKAGE_UPDATE_SUCCESS";
export const SMS_PACKAGE_UPDATE_FAIL = "SMS_PACKAGE_UPDATE_FAIL";
export const SMS_PACKAGE_UPDATE_RESET = "SMS_PACKAGE_UPDATE_RESET";

// Delete
export const SMS_PACKAGE_DELETE_REQUEST = "SMS_PACKAGE_DELETE_REQUEST";
export const SMS_PACKAGE_DELETE_SUCCESS = "SMS_PACKAGE_DELETE_SUCCESS";
export const SMS_PACKAGE_DELETE_FAIL = "SMS_PACKAGE_DELETE_FAIL";

// Get paginated
export const SMS_PACKAGE_PAGED_REQUEST = "SMS_PACKAGE_PAGED_REQUEST";
export const SMS_PACKAGE_PAGED_SUCCESS = "SMS_PACKAGE_PAGED_SUCCESS";
export const SMS_PACKAGE_PAGED_FAIL = "SMS_PACKAGE_PAGED_FAIL";

// Get all (unpaged)
export const SMS_PACKAGE_LIST_REQUEST = "SMS_PACKAGE_LIST_REQUEST";
export const SMS_PACKAGE_LIST_SUCCESS = "SMS_PACKAGE_LIST_SUCCESS";
export const SMS_PACKAGE_LIST_FAIL = "SMS_PACKAGE_LIST_FAIL";



// PAYNOW CREDENTIALS
export const PAYNOW_CREDENTIALS_PAGED_REQUEST = "PAYNOW_CREDENTIALS_PAGED_REQUEST";
export const PAYNOW_CREDENTIALS_PAGED_SUCCESS = "PAYNOW_CREDENTIALS_PAGED_SUCCESS";
export const PAYNOW_CREDENTIALS_PAGED_FAIL = "PAYNOW_CREDENTIALS_PAGED_FAIL";

export const PAYNOW_CREDENTIAL_CREATE_REQUEST = "PAYNOW_CREDENTIAL_CREATE_REQUEST";
export const PAYNOW_CREDENTIAL_CREATE_SUCCESS = "PAYNOW_CREDENTIAL_CREATE_SUCCESS";
export const PAYNOW_CREDENTIAL_CREATE_FAIL = "PAYNOW_CREDENTIAL_CREATE_FAIL";
export const PAYNOW_CREDENTIAL_CREATE_RESET = "PAYNOW_CREDENTIAL_CREATE_RESET";

export const PAYNOW_CREDENTIAL_UPDATE_REQUEST = "PAYNOW_CREDENTIAL_UPDATE_REQUEST";
export const PAYNOW_CREDENTIAL_UPDATE_SUCCESS = "PAYNOW_CREDENTIAL_UPDATE_SUCCESS";
export const PAYNOW_CREDENTIAL_UPDATE_FAIL = "PAYNOW_CREDENTIAL_UPDATE_FAIL";
export const PAYNOW_CREDENTIAL_UPDATE_RESET = "PAYNOW_CREDENTIAL_UPDATE_RESET";

export const PAYNOW_CREDENTIAL_DELETE_REQUEST = "PAYNOW_CREDENTIAL_DELETE_REQUEST";
export const PAYNOW_CREDENTIAL_DELETE_SUCCESS = "PAYNOW_CREDENTIAL_DELETE_SUCCESS";
export const PAYNOW_CREDENTIAL_DELETE_FAIL = "PAYNOW_CREDENTIAL_DELETE_FAIL";



// ************ File Management Constants ************

// Upload File
export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST';
export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';
export const UPLOAD_FILE_RESET = 'UPLOAD_FILE_RESET';

// Delete File
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAIL = 'DELETE_FILE_FAIL';
export const DELETE_FILE_RESET = 'DELETE_FILE_RESET';

// Create Directory
export const CREATE_DIRECTORY_REQUEST = 'CREATE_DIRECTORY_REQUEST';
export const CREATE_DIRECTORY_SUCCESS = 'CREATE_DIRECTORY_SUCCESS';
export const CREATE_DIRECTORY_FAIL = 'CREATE_DIRECTORY_FAIL';
export const CREATE_DIRECTORY_RESET = 'CREATE_DIRECTORY_RESET';

export const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAIL = 'DOWNLOAD_FILE_FAIL';
export const DOWNLOAD_FILE_RESET = 'DOWNLOAD_FILE_RESET';

// PRODUCT CATEGORIES
export const PRODUCT_CATEGORY_LIST_REQUEST = "PRODUCT_CATEGORY_LIST_REQUEST";
export const PRODUCT_CATEGORY_LIST_SUCCESS = "PRODUCT_CATEGORY_LIST_SUCCESS";
export const PRODUCT_CATEGORY_LIST_FAIL = "PRODUCT_CATEGORY_LIST_FAIL";

export const PRODUCT_CATEGORY_PAGED_REQUEST = "PRODUCT_CATEGORY_PAGED_REQUEST";
export const PRODUCT_CATEGORY_PAGED_SUCCESS = "PRODUCT_CATEGORY_PAGED_SUCCESS";
export const PRODUCT_CATEGORY_PAGED_FAIL = "PRODUCT_CATEGORY_PAGED_FAIL";

export const PRODUCT_CATEGORY_DETAILS_REQUEST = "PRODUCT_CATEGORY_DETAILS_REQUEST";
export const PRODUCT_CATEGORY_DETAILS_SUCCESS = "PRODUCT_CATEGORY_DETAILS_SUCCESS";
export const PRODUCT_CATEGORY_DETAILS_FAIL = "PRODUCT_CATEGORY_DETAILS_FAIL";

export const PRODUCT_CATEGORY_CREATE_REQUEST = "PRODUCT_CATEGORY_CREATE_REQUEST";
export const PRODUCT_CATEGORY_CREATE_SUCCESS = "PRODUCT_CATEGORY_CREATE_SUCCESS";
export const PRODUCT_CATEGORY_CREATE_FAIL = "PRODUCT_CATEGORY_CREATE_FAIL";
export const PRODUCT_CATEGORY_CREATE_RESET = "PRODUCT_CATEGORY_CREATE_RESET";

export const PRODUCT_CATEGORY_UPDATE_REQUEST = "PRODUCT_CATEGORY_UPDATE_REQUEST";
export const PRODUCT_CATEGORY_UPDATE_SUCCESS = "PRODUCT_CATEGORY_UPDATE_SUCCESS";
export const PRODUCT_CATEGORY_UPDATE_FAIL = "PRODUCT_CATEGORY_UPDATE_FAIL";
export const PRODUCT_CATEGORY_UPDATE_RESET = "PRODUCT_CATEGORY_UPDATE_RESET";

export const PRODUCT_CATEGORY_DELETE_REQUEST = "PRODUCT_CATEGORY_DELETE_REQUEST";
export const PRODUCT_CATEGORY_DELETE_SUCCESS = "PRODUCT_CATEGORY_DELETE_SUCCESS";
export const PRODUCT_CATEGORY_DELETE_FAIL = "PRODUCT_CATEGORY_DELETE_FAIL";



// Products
export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAIL = "CREATE_PRODUCT_FAIL";
export const CREATE_PRODUCT_RESET = "CREATE_PRODUCT_RESET";

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";
export const UPDATE_PRODUCT_RESET = "UPDATE_PRODUCT_RESET";

export const GET_PRODUCT_REQUEST = "GET_PRODUCT_REQUEST";
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS";
export const GET_PRODUCT_FAIL = "GET_PRODUCT_FAIL";
export const GET_PRODUCT_RESET = "GET_PRODUCT_RESET";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";
export const DELETE_PRODUCT_RESET = "DELETE_PRODUCT_RESET";

export const GET_PAGED_PRODUCTS_REQUEST = "GET_PAGED_PRODUCTS_REQUEST";
export const GET_PAGED_PRODUCTS_SUCCESS = "GET_PAGED_PRODUCTS_SUCCESS";
export const GET_PAGED_PRODUCTS_FAIL = "GET_PAGED_PRODUCTS_FAIL";
export const GET_PAGED_PRODUCTS_RESET = "GET_PAGED_PRODUCTS_RESET";

// ----------------- PRODUCTS BY SUPPLIER -----------------
export const GET_PRODUCTS_BY_SUPPLIER_REQUEST = "GET_PRODUCTS_BY_SUPPLIER_REQUEST";
export const GET_PRODUCTS_BY_SUPPLIER_SUCCESS = "GET_PRODUCTS_BY_SUPPLIER_SUCCESS";
export const GET_PRODUCTS_BY_SUPPLIER_FAIL = "GET_PRODUCTS_BY_SUPPLIER_FAIL";
export const GET_PRODUCTS_BY_SUPPLIER_RESET = "GET_PRODUCTS_BY_SUPPLIER_RESET";

// ----------------- PRODUCTS BY SUBCATEGORY -----------------
export const GET_PRODUCTS_BY_SUBCATEGORY_REQUEST = "GET_PRODUCTS_BY_SUBCATEGORY_REQUEST";
export const GET_PRODUCTS_BY_SUBCATEGORY_SUCCESS = "GET_PRODUCTS_BY_SUBCATEGORY_SUCCESS";
export const GET_PRODUCTS_BY_SUBCATEGORY_FAIL = "GET_PRODUCTS_BY_SUBCATEGORY_FAIL";
export const GET_PRODUCTS_BY_SUBCATEGORY_RESET = "GET_PRODUCTS_BY_SUBCATEGORY_RESET";

// Stock Overview
export const GET_STOCK_OVERVIEW_REQUEST = "GET_STOCK_OVERVIEW_REQUEST";
export const GET_STOCK_OVERVIEW_SUCCESS = "GET_STOCK_OVERVIEW_SUCCESS";
export const GET_STOCK_OVERVIEW_FAIL = "GET_STOCK_OVERVIEW_FAIL";

// Stock Summary
export const GET_STOCK_SUMMARY_REQUEST = "GET_STOCK_SUMMARY_REQUEST";
export const GET_STOCK_SUMMARY_SUCCESS = "GET_STOCK_SUMMARY_SUCCESS";
export const GET_STOCK_SUMMARY_FAIL = "GET_STOCK_SUMMARY_FAIL";

// Update Stock
export const UPDATE_PRODUCT_STOCK_REQUEST = "UPDATE_PRODUCT_STOCK_REQUEST";
export const UPDATE_PRODUCT_STOCK_SUCCESS = "UPDATE_PRODUCT_STOCK_SUCCESS";
export const UPDATE_PRODUCT_STOCK_FAIL = "UPDATE_PRODUCT_STOCK_FAIL";

// Refresh Stock Statuses
export const REFRESH_STOCK_STATUSES_REQUEST = "REFRESH_STOCK_STATUSES_REQUEST";
export const REFRESH_STOCK_STATUSES_SUCCESS = "REFRESH_STOCK_STATUSES_SUCCESS";
export const REFRESH_STOCK_STATUSES_FAIL = "REFRESH_STOCK_STATUSES_FAIL";


// ----------------- PRODUCTS BY CATEGORY -----------------
export const GET_PRODUCTS_BY_CATEGORY_REQUEST = "GET_PRODUCTS_BY_CATEGORY_REQUEST";
export const GET_PRODUCTS_BY_CATEGORY_SUCCESS = "GET_PRODUCTS_BY_CATEGORY_SUCCESS";
export const GET_PRODUCTS_BY_CATEGORY_FAIL = "GET_PRODUCTS_BY_CATEGORY_FAIL";
export const GET_PRODUCTS_BY_CATEGORY_RESET = "GET_PRODUCTS_BY_CATEGORY_RESET";


export const GROUPS_LIST_REQUEST = 'GROUPS_LIST_REQUEST';
export const GROUPS_LIST_SUCCESS = 'GROUPS_LIST_SUCCESS';
export const GROUPS_LIST_FAIL = 'GROUPS_LIST_FAIL';
export const GROUPS_LIST_RESET = 'GROUPS_LIST_RESET';

export const GROUPS_UNPAGED_REQUEST = "GROUPS_UNPAGED_REQUEST";
export const GROUPS_UNPAGED_SUCCESS = "GROUPS_UNPAGED_SUCCESS";
export const GROUPS_UNPAGED_FAIL = "GROUPS_UNPAGED_FAIL";
export const GROUPS_UNPAGED_RESET = "GROUPS_UNPAGED_RESET";



export const ADMIN_GROUPS_LIST_REQUEST = 'ADMIN_GROUPS_LIST_REQUEST';
export const ADMIN_GROUPS_LIST_SUCCESS = 'ADMIN_GROUPS_LIST_SUCCESS';
export const ADMIN_GROUPS_LIST_FAIL = 'ADMIN_GROUPS_LIST_FAIL';
export const ADMIN_GROUPS_LIST_RESET = 'ADMIN_GROUPS_LIST_RESET';

export const GROUP_DETAILS_REQUEST = 'GROUP_DETAILS_REQUEST';
export const GROUP_DETAILS_SUCCESS = 'GROUP_DETAILS_SUCCESS';
export const GROUP_DETAILS_FAIL = 'GROUP_DETAILS_FAIL';
export const GROUP_DETAILS_RESET = 'GROUP_DETAILS_RESET';

export const GROUP_CREATE_REQUEST = 'GROUP_CREATE_REQUEST';
export const GROUP_CREATE_SUCCESS = 'GROUP_CREATE_SUCCESS';
export const GROUP_CREATE_FAIL = 'GROUP_CREATE_FAIL';
export const GROUP_CREATE_RESET = 'GROUP_CREATE_RESET';

export const GROUP_UPDATE_REQUEST = 'GROUP_UPDATE_REQUEST';
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS';
export const GROUP_UPDATE_FAIL = 'GROUP_UPDATE_FAIL';
export const GROUP_UPDATE_RESET = 'GROUP_UPDATE_RESET';

export const GROUP_DELETE_REQUEST = 'GROUP_DELETE_REQUEST';
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS';
export const GROUP_DELETE_FAIL = 'GROUP_DELETE_FAIL';
export const GROUP_DELETE_RESET = 'GROUP_DELETE_RESET';

// Group Permissions Constants
export const GROUP_PERMISSIONS_LIST_REQUEST = 'GROUP_PERMISSIONS_LIST_REQUEST';
export const GROUP_PERMISSIONS_LIST_SUCCESS = 'GROUP_PERMISSIONS_LIST_SUCCESS';
export const GROUP_PERMISSIONS_LIST_FAIL = 'GROUP_PERMISSIONS_LIST_FAIL';
export const GROUP_PERMISSIONS_LIST_RESET = 'GROUP_PERMISSIONS_LIST_RESET';

export const GROUP_PERMISSIONS_ALL_REQUEST = 'GROUP_PERMISSIONS_ALL_REQUEST';
export const GROUP_PERMISSIONS_ALL_SUCCESS = 'GROUP_PERMISSIONS_ALL_SUCCESS';
export const GROUP_PERMISSIONS_ALL_FAIL = 'GROUP_PERMISSIONS_ALL_FAIL';
export const GROUP_PERMISSIONS_ALL_RESET = 'GROUP_PERMISSIONS_ALL_RESET';

export const GROUP_PERMISSION_CREATE_REQUEST = 'GROUP_PERMISSION_CREATE_REQUEST';
export const GROUP_PERMISSION_CREATE_SUCCESS = 'GROUP_PERMISSION_CREATE_SUCCESS';
export const GROUP_PERMISSION_CREATE_FAIL = 'GROUP_PERMISSION_CREATE_FAIL';
export const GROUP_PERMISSION_CREATE_RESET = 'GROUP_PERMISSION_CREATE_RESET';

// Bulk create
export const GROUP_PERMISSION_BULK_CREATE_REQUEST = 'GROUP_PERMISSION_BULK_CREATE_REQUEST';
export const GROUP_PERMISSION_BULK_CREATE_SUCCESS = 'GROUP_PERMISSION_BULK_CREATE_SUCCESS';
export const GROUP_PERMISSION_BULK_CREATE_FAIL = 'GROUP_PERMISSION_BULK_CREATE_FAIL';
export const GROUP_PERMISSION_BULK_CREATE_RESET = 'GROUP_PERMISSION_BULK_CREATE_RESET';

export const GROUP_PERMISSION_REVOKE_REQUEST = 'GROUP_PERMISSION_REVOKE_REQUEST';
export const GROUP_PERMISSION_REVOKE_SUCCESS = 'GROUP_PERMISSION_REVOKE_SUCCESS';
export const GROUP_PERMISSION_REVOKE_FAIL = 'GROUP_PERMISSION_REVOKE_FAIL';
export const GROUP_PERMISSION_REVOKE_RESET = 'GROUP_PERMISSION_REVOKE_RESET';

export const GROUP_PERMISSION_BULK_REVOKE_REQUEST = 'GROUP_PERMISSION_BULK_REVOKE_REQUEST';
export const GROUP_PERMISSION_BULK_REVOKE_SUCCESS = 'GROUP_PERMISSION_BULK_REVOKE_SUCCESS';
export const GROUP_PERMISSION_BULK_REVOKE_FAIL = 'GROUP_PERMISSION_BULK_REVOKE_FAIL';
export const GROUP_PERMISSION_BULK_REVOKE_RESET = 'GROUP_PERMISSION_BULK_REVOKE_RESET';

export const GROUP_PERMISSION_UNASSIGNED_REQUEST = 'GROUP_PERMISSION_UNASSIGNED_REQUEST';
export const GROUP_PERMISSION_UNASSIGNED_SUCCESS = 'GROUP_PERMISSION_UNASSIGNED_SUCCESS';
export const GROUP_PERMISSION_UNASSIGNED_FAIL = 'GROUP_PERMISSION_UNASSIGNED_FAIL';
export const GROUP_PERMISSION_UNASSIGNED_RESET = 'GROUP_PERMISSION_UNASSIGNED_RESET';

// Permissions
export const PERMISSIONS_LIST_REQUEST = 'PERMISSIONS_LIST_REQUEST';
export const PERMISSIONS_LIST_SUCCESS = 'PERMISSIONS_LIST_SUCCESS';
export const PERMISSIONS_LIST_FAIL = 'PERMISSIONS_LIST_FAIL';
export const PERMISSIONS_LIST_RESET = 'PERMISSIONS_LIST_RESET'; 

export const PERMISSIONS_ALL_REQUEST = 'PERMISSIONS_ALL_REQUEST';
export const PERMISSIONS_ALL_SUCCESS = 'PERMISSIONS_ALL_SUCCESS';
export const PERMISSIONS_ALL_FAIL = 'PERMISSIONS_ALL_FAIL';
export const PERMISSIONS_ALL_RESET = 'PERMISSIONS_ALL_RESET';

export const PERMISSION_DETAILS_REQUEST = 'PERMISSION_DETAILS_REQUEST';
export const PERMISSION_DETAILS_SUCCESS = 'PERMISSION_DETAILS_SUCCESS';
export const PERMISSION_DETAILS_FAIL = 'PERMISSION_DETAILS_FAIL';
export const PERMISSION_DETAILS_RESET = 'PERMISSION_DETAILS_RESET';

export const PERMISSIONS_CLIENT_ACCESSIBLE_REQUEST = 'PERMISSIONS_CLIENT_ACCESSIBLE_REQUEST';
export const PERMISSIONS_CLIENT_ACCESSIBLE_SUCCESS = 'PERMISSIONS_CLIENT_ACCESSIBLE_SUCCESS';
export const PERMISSIONS_CLIENT_ACCESSIBLE_FAIL = 'PERMISSIONS_CLIENT_ACCESSIBLE_FAIL';
export const PERMISSIONS_CLIENT_ACCESSIBLE_RESET = 'PERMISSIONS_CLIENT_ACCESSIBLE_RESET';

export const PERMISSIONS_CUSTOMER_ACCESSIBLE_REQUEST = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_REQUEST';
export const PERMISSIONS_CUSTOMER_ACCESSIBLE_SUCCESS = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_SUCCESS';
export const PERMISSIONS_CUSTOMER_ACCESSIBLE_FAIL = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_FAIL';
export const PERMISSIONS_CUSTOMER_ACCESSIBLE_RESET = 'PERMISSIONS_CUSTOMER_ACCESSIBLE_RESET';

export const PERMISSION_CREATE_REQUEST = 'PERMISSION_CREATE_REQUEST';
export const PERMISSION_CREATE_SUCCESS = 'PERMISSION_CREATE_SUCCESS';
export const PERMISSION_CREATE_FAIL = 'PERMISSION_CREATE_FAIL';
export const PERMISSION_CREATE_RESET = 'PERMISSION_CREATE_RESET';

export const PERMISSION_BULK_CREATE_REQUEST = 'PERMISSION_BULK_CREATE_REQUEST';
export const PERMISSION_BULK_CREATE_SUCCESS = 'PERMISSION_BULK_CREATE_SUCCESS';
export const PERMISSION_BULK_CREATE_FAIL = 'PERMISSION_BULK_CREATE_FAIL';
export const PERMISSION_BULK_CREATE_RESET = 'PERMISSION_BULK_CREATE_RESET';

export const PERMISSION_UPDATE_REQUEST = 'PERMISSION_UPDATE_REQUEST';
export const PERMISSION_UPDATE_SUCCESS = 'PERMISSION_UPDATE_SUCCESS';
export const PERMISSION_UPDATE_FAIL = 'PERMISSION_UPDATE_FAIL';
export const PERMISSION_UPDATE_RESET = 'PERMISSION_UPDATE_RESET';

export const PERMISSION_DELETE_REQUEST = 'PERMISSION_DELETE_REQUEST';
export const PERMISSION_DELETE_SUCCESS = 'PERMISSION_DELETE_SUCCESS';
export const PERMISSION_DELETE_FAIL = 'PERMISSION_DELETE_FAIL';
export const PERMISSION_DELETE_RESET = 'PERMISSION_DELETE_RESET';



// For getAllUsersAction
export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAIL = 'USER_LIST_FAIL';
export const USER_GET_ALL_RESET = 'USER_GET_ALL_RESET';
export const USER_DELETE_ALL_RESET = 'USER_DELETE_ALL_RESET';
export const USER_DELETE_ALL_REQUEST = 'USER_DELETE_ALL_REQUEST';
export const USER_DELETE_ALL_SUCCESS = 'USER_DELETE_ALL_SUCCESS';
export const USER_DELETE_ALL_FAIL = 'USER_DELETE_ALL_FAIL';

export const USER_DELETE = 'ORDER_DELETE';
export const USER_DELETE_FAIL = 'ORDER_DELETE_FAIL';
export const USER_DELETE_RESET = 'ORDER_DELETE_RESET';

// For viewUserDetailsAction
export const USER_DETAILS_REQUEST = 'USER_DETAILS_REQUEST';
export const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';

export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL';


//user update
export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST';
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
export const USER_UPDATE_FAIL = 'USER_UPDATE_FAIL';
export const USER_UPDATE_RESET = 'USER_UPDATE_RESET';

//reset user 
export const RESET_USER_PASSWORD_REQUEST = 'RESET_USER_PASSWORD_REQUEST';
export const RESET_USER_PASSWORD_SUCCESS = 'RESET_USER_PASSWORD_SUCCESS';
export const RESET_USER_PASSWORD_FAIL = 'RESET_USER_PASSWORD_FAIL';
export const RESET_USER_PASSWORD_RESET = 'RESET_USER_PASSWORD_RESET';

export const VERIFY_ACCOUNT_REQUEST = 'VERIFY_ACCOUNT_REQUEST';
export const VERIFY_ACCOUNT_SUCCESS = 'VERIFY_ACCOUNT_SUCCESS';
export const VERIFY_ACCOUNT_FAIL = 'VERIFY_ACCOUNT_FAIL';
export const VERIFY_ACCOUNT_RESET = 'VERIFY_ACCOUNT_RESET';

export const CHANGE_USER_GROUP_REQUEST = "CHANGE_USER_GROUP_REQUEST";
export const CHANGE_USER_GROUP_SUCCESS = "CHANGE_USER_GROUP_SUCCESS";
export const CHANGE_USER_GROUP_FAIL = "CHANGE_USER_GROUP_FAIL";
export const CHANGE_USER_GROUP_RESET = "CHANGE_USER_GROUP_RESET";

export const CHANGE_USER_STATUS_REQUEST = "CHANGE_USER_STATUS_REQUEST";
export const CHANGE_USER_STATUS_SUCCESS = "CHANGE_USER_STATUS_SUCCESS";
export const CHANGE_USER_STATUS_FAIL = "CHANGE_USER_STATUS_FAIL";
export const CHANGE_USER_STATUS_RESET = "CHANGE_USER_STATUS_RESET";

// User Permissions
// List (paginated)
export const USER_PERMISSIONS_REQUEST = "USER_PERMISSIONS_REQUEST";
export const USER_PERMISSIONS_SUCCESS = "USER_PERMISSIONS_SUCCESS";
export const USER_PERMISSIONS_FAIL = "USER_PERMISSIONS_FAIL";
export const USER_PERMISSIONS_RESET = "USER_PERMISSIONS_RESET";

// List (all)
export const USER_PERMISSIONS_ALL_REQUEST = "USER_PERMISSIONS_ALL_REQUEST";
export const USER_PERMISSIONS_ALL_SUCCESS = "USER_PERMISSIONS_ALL_SUCCESS";
export const USER_PERMISSIONS_ALL_FAIL = "USER_PERMISSIONS_ALL_FAIL";
export const USER_PERMISSIONS_ALL_RESET = "USER_PERMISSIONS_ALL_RESET";

// Assign single
export const ASSIGN_PERMISSION_REQUEST = "ASSIGN_PERMISSION_REQUEST";
export const ASSIGN_PERMISSION_SUCCESS = "ASSIGN_PERMISSION_SUCCESS";
export const ASSIGN_PERMISSION_FAIL = "ASSIGN_PERMISSION_FAIL";
export const ASSIGN_PERMISSION_RESET = "ASSIGN_PERMISSION_RESET";

// Assign bulk
export const ASSIGN_BULK_PERMISSION_REQUEST = "ASSIGN_BULK_PERMISSION_REQUEST";
export const ASSIGN_BULK_PERMISSION_SUCCESS = "ASSIGN_BULK_PERMISSION_SUCCESS";
export const ASSIGN_BULK_PERMISSION_FAIL = "ASSIGN_BULK_PERMISSION_FAIL";
export const ASSIGN_BULK_PERMISSION_RESET = "ASSIGN_BULK_PERMISSION_RESET";

// Revoke single
export const REVOKE_PERMISSION_REQUEST = "REVOKE_PERMISSION_REQUEST";
export const REVOKE_PERMISSION_SUCCESS = "REVOKE_PERMISSION_SUCCESS";
export const REVOKE_PERMISSION_FAIL = "REVOKE_PERMISSION_FAIL";
export const REVOKE_PERMISSION_RESET = "REVOKE_PERMISSION_RESET";

// Revoke bulk
export const REVOKE_BULK_PERMISSION_REQUEST = "REVOKE_BULK_PERMISSION_REQUEST";
export const REVOKE_BULK_PERMISSION_SUCCESS = "REVOKE_BULK_PERMISSION_SUCCESS";
export const REVOKE_BULK_PERMISSION_FAIL = "REVOKE_BULK_PERMISSION_FAIL";
export const REVOKE_BULK_PERMISSION_RESET = "REVOKE_BULK_PERMISSION_RESET";

// Unassigned
export const UNASSIGNED_PERMISSIONS_REQUEST = "UNASSIGNED_PERMISSIONS_REQUEST";
export const UNASSIGNED_PERMISSIONS_SUCCESS = "UNASSIGNED_PERMISSIONS_SUCCESS";
export const UNASSIGNED_PERMISSIONS_FAIL = "UNASSIGNED_PERMISSIONS_FAIL";
export const UNASSIGNED_PERMISSIONS_RESET = "UNASSIGNED_PERMISSIONS_RESET";

// Unassigned (client)
export const UNASSIGNED_CLIENT_PERMISSIONS_REQUEST = "UNASSIGNED_CLIENT_PERMISSIONS_REQUEST";
export const UNASSIGNED_CLIENT_PERMISSIONS_SUCCESS = "UNASSIGNED_CLIENT_PERMISSIONS_SUCCESS";
export const UNASSIGNED_CLIENT_PERMISSIONS_FAIL = "UNASSIGNED_CLIENT_PERMISSIONS_FAIL";
export const UNASSIGNED_CLIENT_PERMISSIONS_RESET = "UNASSIGNED_CLIENT_PERMISSIONS_RESET";



//roles
export const ROLES_LIST_REQUEST = 'ROLES_LIST_REQUEST';
export const ROLES_LIST_SUCCESS = 'ROLES_LIST_SUCCESS';
export const ROLES_LIST_FAIL = 'ROLES_LIST_FAIL';
export const ROLES_LIST_RESET = 'ROLES_LIST_RESET';



export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAIL = 'PROFILE_UPDATE_FAIL';
export const PROFILE_UPDATE_RESET = 'PROFILE_UPDATE_RESET';

export const PASSWORD_CHANGE_REQUEST = 'PASSWORD_CHANGE_REQUEST';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';
export const PASSWORD_CHANGE_FAIL = 'PASSWORD_CHANGE_FAIL';
export const PASSWORD_CHANGE_RESET = 'PASSWORD_CHANGE_RESET';


//notifications
export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST';
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS';
export const NOTIFICATION_LIST_FAIL = 'NOTIFICATION_LIST_FAIL';
export const NOTIFICATION_LIST_RESET = 'NOTIFICATION_LIST_RESET';

export const NOTIFICATION_READ_ALL_REQUEST = 'NOTIFICATION_READ_ALL_REQUEST';
export const NOTIFICATION_READ_ALL_SUCCESS = 'NOTIFICATION_READ_ALL_SUCCESS';
export const NOTIFICATION_READ_ALL_FAIL = 'NOTIFICATION_READ_ALL_FAIL';
export const NOTIFICATION_READ_ALL_RESET = 'NOTIFICATION_READ_ALL_RESET'

export const GET_NOTIFICATION_REQUEST = 'GET_NOTIFICATION_REQUEST';
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';
export const GET_NOTIFICATION_FAIL = 'GET_NOTIFICATION_FAIL';
export const GET_NOTIFICATION_RESET = 'GET_NOTIFICATION_RESET';

export const ADD_NOTIFICATION_SUCCESS = 'ADD_NOTIFICATION_SUCCESS';
export const ADD_NOTIFICATION_FAIL = 'ADD_NOTIFICATION_FAIL';
export const NOTIFICATION_REGISTER_REQUEST = 'NOTIFICATION_REGISTER_REQUEST'
export const NOTIFICATION_REGISTER_RESET = 'NOTIFICATION_REGISTER_RESET'

export const DELETE_NOTIFICATION_SUCCESS = 'DELETE_NOTIFICATION_SUCCESS';
export const DELETE_NOTIFICATION_FAIL = 'DELETE_NOTIFICATION_FAIL';
export const DELETE_NOTIFICATION_RESET = 'PRODUCT_NOTIFICATION_RESET';
export const DELETE_NOTIFICATION_REQUEST = 'DELETE_NOTIFICATION_REQUEST';

export const NOTIFICATION_DETAILS_SUCCESS = 'NOTIFICATION_DETAILS_SUCCESS';
export const NOTIFICATION_DETAILS_FAIL = 'NOTIFICATION_DETAILS_FAIL';
export const NOTIFICATION_DETAILS_REQUEST = 'NOTIFICATION_DETAILS_REQUEST';

export const NOTIFICATION_UPDATE_REQUEST = 'NOTIFICATION_UPDATE_REQUEST';
export const NOTIFICATION_UPDATE_SUCCESS = 'NOTIFICATION_UPDATE_SUCCESS';
export const NOTIFICATION_UPDATE_FAIL = 'NOTIFICATION_UPDATE_FAIL';
export const NOTIFICATION_UPDATE_RESET = 'NOTIFICATION_UPDATE_RESET';

export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';

// Transactions
export const TRANSACTIONS_LIST_REQUEST = 'TRANSACTIONS_LIST_REQUEST';
export const TRANSACTIONS_LIST_SUCCESS = 'TRANSACTIONS_LIST_SUCCESS';
export const TRANSACTIONS_LIST_FAIL = 'TRANSACTIONS_LIST_FAIL';
export const TRANSACTIONS_LIST_RESET = 'TRANSACTIONS_LIST_RESET';

export const TRANSACTION_DETAILS_REQUEST = 'TRANSACTION_DETAILS_REQUEST';
export const TRANSACTION_DETAILS_SUCCESS = 'TRANSACTION_DETAILS_SUCCESS';
export const TRANSACTION_DETAILS_FAIL = 'TRANSACTION_DETAILS_FAIL';
export const TRANSACTION_DETAILS_RESET = 'TRANSACTION_DETAILS_RESET';

export const TRANSACTIONS_SEARCH_REQUEST = 'TRANSACTIONS_SEARCH_REQUEST';
export const TRANSACTIONS_SEARCH_SUCCESS = 'TRANSACTIONS_SEARCH_SUCCESS';
export const TRANSACTIONS_SEARCH_FAIL = 'TRANSACTIONS_SEARCH_FAIL';

export const TRANSACTIONS_PERIOD_REQUEST = 'TRANSACTIONS_PERIOD_REQUEST';
export const TRANSACTIONS_PERIOD_SUCCESS = 'TRANSACTIONS_PERIOD_SUCCESS';
export const TRANSACTIONS_PERIOD_FAIL = 'TRANSACTIONS_PERIOD_FAIL';

export const TRANSACTIONS_PERIOD_STATUS_REQUEST = 'TRANSACTIONS_PERIOD_STATUS_REQUEST';
export const TRANSACTIONS_PERIOD_STATUS_SUCCESS = 'TRANSACTIONS_PERIOD_STATUS_SUCCESS';
export const TRANSACTIONS_PERIOD_STATUS_FAIL = 'TRANSACTIONS_PERIOD_STATUS_FAIL';

export const TRANSACTIONS_METRICS_REQUEST = 'TRANSACTIONS_METRICS_REQUEST';
export const TRANSACTIONS_METRICS_SUCCESS = 'TRANSACTIONS_METRICS_SUCCESS';
export const TRANSACTIONS_METRICS_FAIL = 'TRANSACTIONS_METRICS_FAIL';
export const TRANSACTIONS_METRICS_RESET = 'TRANSACTIONS_METRICS_RESET';

export const TRANSACTIONS_EXPORT_REQUEST = 'TRANSACTIONS_EXPORT_REQUEST';
export const TRANSACTIONS_EXPORT_SUCCESS = 'TRANSACTIONS_EXPORT_SUCCESS';
export const TRANSACTIONS_EXPORT_FAIL = 'TRANSACTIONS_EXPORT_FAIL';
export const TRANSACTIONS_EXPORT_RESET = 'TRANSACTIONS_EXPORT_RESET';

export const TRANSACTIONS_REPORT_STATUS_REQUEST = "TRANSACTIONS_REPORT_STATUS_REQUEST";
export const TRANSACTIONS_REPORT_STATUS_SUCCESS = "TRANSACTIONS_REPORT_STATUS_SUCCESS";
export const TRANSACTIONS_REPORT_STATUS_FAIL = "TRANSACTIONS_REPORT_STATUS_FAIL";
export const TRANSACTIONS_REPORT_STATUS_RESET = "TRANSACTIONS_REPORT_STATUS_RESET";

export const TRANSACTIONS_REPORT_PERIOD_REQUEST = "TRANSACTIONS_REPORT_PERIOD_REQUEST";
export const TRANSACTIONS_REPORT_PERIOD_SUCCESS = "TRANSACTIONS_REPORT_PERIOD_SUCCESS";
export const TRANSACTIONS_REPORT_PERIOD_FAIL = "TRANSACTIONS_REPORT_PERIOD_FAIL";
export const TRANSACTIONS_REPORT_PERIOD_RESET = "TRANSACTIONS_REPORT_PERIOD_RESET";

// CURRENCY CONSTANTS
export const CURRENCY_LIST_REQUEST = "CURRENCY_LIST_REQUEST";
export const CURRENCY_LIST_SUCCESS = "CURRENCY_LIST_SUCCESS";
export const CURRENCY_LIST_FAIL = "CURRENCY_LIST_FAIL";

export const CURRENCY_PAGED_REQUEST = "CURRENCY_PAGED_REQUEST";
export const CURRENCY_PAGED_SUCCESS = "CURRENCY_PAGED_SUCCESS";
export const CURRENCY_PAGED_FAIL = "CURRENCY_PAGED_FAIL";

export const CURRENCY_DETAILS_REQUEST = "CURRENCY_DETAILS_REQUEST";
export const CURRENCY_DETAILS_SUCCESS = "CURRENCY_DETAILS_SUCCESS";
export const CURRENCY_DETAILS_FAIL = "CURRENCY_DETAILS_FAIL";

export const CURRENCY_CREATE_REQUEST = "CURRENCY_CREATE_REQUEST";
export const CURRENCY_CREATE_SUCCESS = "CURRENCY_CREATE_SUCCESS";
export const CURRENCY_CREATE_FAIL = "CURRENCY_CREATE_FAIL";
export const CURRENCY_CREATE_RESET = "CURRENCY_CREATE_RESET";

export const CURRENCY_UPDATE_REQUEST = "CURRENCY_UPDATE_REQUEST";
export const CURRENCY_UPDATE_SUCCESS = "CURRENCY_UPDATE_SUCCESS";
export const CURRENCY_UPDATE_FAIL = "CURRENCY_UPDATE_FAIL";
export const CURRENCY_UPDATE_RESET = "CURRENCY_UPDATE_RESET";

export const CURRENCY_DELETE_REQUEST = "CURRENCY_DELETE_REQUEST";
export const CURRENCY_DELETE_SUCCESS = "CURRENCY_DELETE_SUCCESS";
export const CURRENCY_DELETE_FAIL = "CURRENCY_DELETE_FAIL";

// In your Constants/AllConstants.js file, add:

// Orders List
export const ORDERS_LIST_REQUEST = 'ORDERS_LIST_REQUEST';
export const ORDERS_LIST_SUCCESS = 'ORDERS_LIST_SUCCESS';
export const ORDERS_LIST_FAIL = 'ORDERS_LIST_FAIL';
export const ORDERS_LIST_RESET = 'ORDERS_LIST_RESET';

// Order Details
export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';
export const ORDER_DETAILS_RESET = 'ORDER_DETAILS_RESET';

// Order Items
export const ORDER_ITEMS_REQUEST = 'ORDER_ITEMS_REQUEST';
export const ORDER_ITEMS_SUCCESS = 'ORDER_ITEMS_SUCCESS';
export const ORDER_ITEMS_FAIL = 'ORDER_ITEMS_FAIL';

// Order Stats/Dashboard Metrics
export const ORDER_STATS_REQUEST = 'ORDER_STATS_REQUEST';
export const ORDER_STATS_SUCCESS = 'ORDER_STATS_SUCCESS';
export const ORDER_STATS_FAIL = 'ORDER_STATS_FAIL';
export const ORDER_STATS_RESET = 'ORDER_STATS_RESET';

// Complete Order (Cash)
export const ORDER_COMPLETE_REQUEST = 'ORDER_COMPLETE_REQUEST';
export const ORDER_COMPLETE_SUCCESS = 'ORDER_COMPLETE_SUCCESS';
export const ORDER_COMPLETE_FAIL = 'ORDER_COMPLETE_FAIL';
export const ORDER_COMPLETE_RESET = 'ORDER_COMPLETE_RESET';

// User Orders
export const USER_ORDERS_REQUEST = 'USER_ORDERS_REQUEST';
export const USER_ORDERS_SUCCESS = 'USER_ORDERS_SUCCESS';
export const USER_ORDERS_FAIL = 'USER_ORDERS_FAIL';

export const PROCESSING_FEES_LIST_REQUEST = 'PROCESSING_FEES_LIST_REQUEST';
export const PROCESSING_FEES_LIST_SUCCESS = 'PROCESSING_FEES_LIST_SUCCESS';
export const PROCESSING_FEES_LIST_FAIL = 'PROCESSING_FEES_LIST_FAIL';
export const PROCESSING_FEES_LIST_RESET = 'PROCESSING_FEES_LIST_RESET';

export const ORDER_FEES_REQUEST = 'ORDER_FEES_REQUEST';
export const ORDER_FEES_SUCCESS = 'ORDER_FEES_SUCCESS';
export const ORDER_FEES_FAIL = 'ORDER_FEES_FAIL';
export const ORDER_FEES_RESET = 'ORDER_FEES_RESET';